import React, { useState } from "react";

const N8N_WEBHOOK_URL = "https://n8n.cogniiq.co/webhook/contact";

function isEmail(v: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

export default function ContactForm() {
  const [status, setStatus] = useState<null | { ok: boolean; msg: string }>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const data = {
      name: String(fd.get("name") || "").trim(),
      email: String(fd.get("email") || "").trim(),
      subject: String(fd.get("subject") || "").trim(),
      message: String(fd.get("message") || "").trim(),
    };

    const emailOk = isEmail(data.email);
    const messageOk = data.message.length >= 3;
    const subjectOk = data.subject.length > 0;
    const gdprOk = (fd.get("gdpr") as string | null) === "on";

    if (!emailOk || !messageOk || !subjectOk || !gdprOk) {
      setStatus({ ok: false, msg: "Bitte fülle alle Pflichtfelder korrekt aus." });
      return;
    }

    try {
      setSubmitting(true);
      setStatus(null);
      await fetch(N8N_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).catch(() => {});
      window.location.href = "/contact/success";
    } catch {
      window.location.href = "/contact/success";
    }
  }

  return (
    <div className="w-full">
      {status && !status.ok && (
        <div
          role="status"
          aria-live="polite"
          className="mb-5 rounded-[12px] p-4 text-[13px] bg-red-50 border border-red-100 text-red-700"
        >
          {status.msg}
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-4" noValidate>
        <input name="company" autoComplete="off" tabIndex={-1} className="hidden" aria-hidden="true" />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="name" className="block text-[13px] font-semibold text-[color:var(--svh-ink)] mb-2">Name</label>
            <input
              id="name" name="name"
              className="w-full px-4 py-3 border border-gray-200 rounded-[12px] focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none text-[13px] transition-all bg-gray-50/50 focus:bg-white"
              autoComplete="name"
              placeholder="Max Mustermann"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-[13px] font-semibold text-[color:var(--svh-ink)] mb-2">E-Mail *</label>
            <input
              id="email" name="email" type="email" required
              className="w-full px-4 py-3 border border-gray-200 rounded-[12px] focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none text-[13px] transition-all bg-gray-50/50 focus:bg-white"
              autoComplete="email"
              placeholder="max@beispiel.de"
            />
          </div>
        </div>

        <div>
          <label htmlFor="subject" className="block text-[13px] font-semibold text-[color:var(--svh-ink)] mb-2">Betreff *</label>
          <input
            id="subject" name="subject" required
            className="w-full px-4 py-3 border border-gray-200 rounded-[12px] focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none text-[13px] transition-all bg-gray-50/50 focus:bg-white"
            placeholder="Worum geht es?"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-[13px] font-semibold text-[color:var(--svh-ink)] mb-2">Nachricht *</label>
          <textarea
            id="message" name="message" required rows={5}
            className="w-full px-4 py-3 border border-gray-200 rounded-[12px] focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none text-[13px] transition-all resize-none bg-gray-50/50 focus:bg-white"
            placeholder="Ihre Nachricht an uns..."
          />
        </div>

        <div className="flex items-start gap-3">
          <input id="gdpr" name="gdpr" type="checkbox" required className="mt-1 w-4 h-4 rounded border-gray-300 text-red-600 focus:ring-red-500" />
          <label htmlFor="gdpr" className="text-[13px] text-[color:var(--svh-ink-2)] leading-relaxed">
            Ich stimme zu, dass meine Angaben zur Beantwortung meiner Anfrage verarbeitet werden. Datenschutzhinweise beachtet.
          </label>
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="w-full svh-btn svh-btn--primary svh-focus disabled:opacity-50"
        >
          {submitting ? "Senden…" : "Anfrage senden"}
        </button>
      </form>
    </div>
  );
}
